export const AGENT_AVATAR_NAVIGATION_TEST_ID = 'agent-avatar';
